import { COLORS } from 'styles/constants';

export const CloseModalIcon = ({ height, width }: { height: number; width: number }) => (
  <svg fill="none" height={height} width={width} xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" fill={COLORS.primary} transform="rotate(-90 20 20)" r="20" />
    <circle cx="20" cy="20" r="15.5" stroke={COLORS.white} />
    <path
      d="M20.704 20.003l4.95-4.95-.708-.707-4.95 4.95-4.949-4.95-.707.707 4.95 4.95-4.95 4.95.707.707 4.95-4.95 4.95 4.95.707-.707z"
      fill={COLORS.white}
    />
  </svg>
);
